/* unplugin-vue-components disabled */import { render } from "./dsapp.vue?vue&type=template&id=6505ef75&scoped=true"
import script from "./dsapp.vue?vue&type=script&lang=js"
export * from "./dsapp.vue?vue&type=script&lang=js"

import "./dsapp.vue?vue&type=style&index=0&id=6505ef75&lang=scss&scoped=true"
import "./dsapp.vue?vue&type=style&index=1&id=6505ef75&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6505ef75"]])

export default __exports__